import { apiErrorHandler } from "@/helpers/apiErrorHandler";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { Loader2 } from "lucide-react";
import { useState } from "react";

export default function ConfirmAlertDialog({
    open,
    onClose,
    title = "Are you absolutely sure?",
    description = "This action cannot be undone.",
    onConfirm,
}) {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async (e) => {
        e.preventDefault(); // prevent dialog auto close

        try {
            setLoading(true);
            await onConfirm?.();
            onClose(false); // close dialog after success
        } catch (err) {
            apiErrorHandler(err)
        } finally {
            setLoading(false);
        }
    };

    return (
        <AlertDialog.Root open={open} onOpenChange={onClose}>
            <AlertDialog.Portal>

                {/* Overlay */}
                <AlertDialog.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" />

                {/* Dialog */}
                <AlertDialog.Content
                    className="fixed left-1/2 top-1/2 z-50 w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-2xl"
                >
                    <AlertDialog.Title className="text-lg font-semibold">
                        {title}
                    </AlertDialog.Title>

                    <AlertDialog.Description className="mt-2 text-sm text-gray-500">
                        {description}
                    </AlertDialog.Description>

                    {/* Buttons */}
                    <div className="mt-6 flex justify-end gap-3">

                        <AlertDialog.Cancel asChild>
                            <button
                                disabled={loading}
                                className="rounded-lg border px-4 py-2 text-sm hover:bg-gray-100 disabled:opacity-50"
                            >
                                Cancel
                            </button>
                        </AlertDialog.Cancel>

                        <AlertDialog.Action asChild>
                            <button
                                onClick={handleConfirm}
                                disabled={loading}
                                className="flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-700 disabled:opacity-70"
                            >
                                {loading && (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                )}

                                {loading ? "Processing..." : "Confirm"}
                            </button>
                        </AlertDialog.Action>

                    </div>

                </AlertDialog.Content>

            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
}